import ContentSection from './components/ContentSection';
import { ScopeOfPracticeWrapper } from './styles';

const ScopeOfPractice = () => {
  return (
    <ScopeOfPracticeWrapper>
      <ContentSection />
    </ScopeOfPracticeWrapper>
  );
};

export default ScopeOfPractice;
